import React from 'react';
import styled from 'styled-components';
import H1 from 'components/text/H1';
import application from 'lib/application';

const VerifyEmailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const VerifyEmail = () => {
  return (
    <VerifyEmailWrapper>
      <H1>A verification email has been sent to {application.email}</H1>
      <p>Please check your inbox to confirm your email address.</p>
    </VerifyEmailWrapper>
  );
}

export default VerifyEmail;
